module.exports = __webpack_public_path__ + "static/media/rus-flag.4c31d63e.svg";